import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.scss'],
  providers: [AngularFireDatabase, AngularFireAuth],
})
export class TopicComponent implements OnInit {
  topic : any = {};
  topicId : any;
  sub : any;
  forums : Observable<any[]>;
  user : any;
  profile: any;

  constructor(private db: AngularFireDatabase, private route : ActivatedRoute, private afAuth : AngularFireAuth) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
     this.topicId = params['id'];

     this.db.object('topics/'+this.topicId)
        .snapshotChanges()
        .subscribe(topic => {
          this.topic = topic.payload.val();
        });

     this.forums = this.db.list('discussions', ref => ref.orderByChild('topicId').equalTo(this.topicId))
      .snapshotChanges().map(changes => {
        return changes.map(c => ({ key: c.key, ...c.payload.val() }));
      });
    });

    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
      this.db.object(`profiles/${user.uid}`).valueChanges().subscribe(value => {
        this.profile = value;
      });
    });
  }

  subscribed() {
    return this.profile && this.profile.notifications ? this.profile.notifications.indexOf(this.topicId > -1) : false;
  }

  toggleSubscription() {
    let objectRef = this.db.object(`profiles/${this.user.uid}`);
    let notifications = this.profile.notifications ? this.profile.notifications : [];
    
    if (this.subscribed()) {
      let index = this.profile.notifications.indexOf(this.topicId);
      notifications.splice(index, 1);
    } else {
      notifications.push(this.topicId);
    }

    objectRef.update({
      notifications
    })
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/topics/topic/topic.component.ts